<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title title="委托方信息" />
      </div>
      <div class="section-content">
        <jczh-descriptions
          :info="detailInfo"
          :option="detailConfig"
          :el-attrs="{
            size: 'medium',
            labelStyle: {
              whiteSpace: 'nowrap'
            }
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

export default {
  components: {
    BaseSectionTitle
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      detailConfig: [
        { label: '委托单位名称', prop: 'purchaseCompanyName' },
        { label: '联系人', prop: 'purchaseLink' },
        { label: '联系方式', prop: 'linkTelephone' }
      ]
    }
  }
}
</script>
